module.exports = __webpack_public_path__ + "media/customizations/furstranch/logo-30ae5a1a41608865d06070f4c7ad8389.png";